import { BaseEvent, EventEmitter, eventRegistry } from "@Context/common/general/event-context";
import * as t from "io-ts";

const DemoConversionStartedCodec = t.type({
  type: t.literal("demo:conversion:started"),
  timestamp: t.number,
});

const DemoConversionResolvedCodec = t.type({
  type: t.literal("demo:conversion:resolved"),
  timestamp: t.number,
  success: t.boolean,
});

export interface DemoConversionStartedEvent extends BaseEvent {
  type: "demo:conversion:started";
}

export interface DemoConversionResolvedEvent extends BaseEvent {
  type: "demo:conversion:resolved";
  success: boolean;
}

export const demoConversionStartedEmitter = eventRegistry.registerEventType<
  typeof DemoConversionStartedCodec,
  DemoConversionStartedEvent
>("demo:conversion:started", DemoConversionStartedCodec);

export const demoConversionResolvedEmitter = eventRegistry.registerEventType<
  typeof DemoConversionResolvedCodec,
  DemoConversionResolvedEvent
>("demo:conversion:resolved", DemoConversionResolvedCodec);

